import axios from 'axios';
import { isArray, isEqual, isNull, omitBy, pick } from 'lodash';

const defaultState = {
  parameters: {}, // The parameters in the search bar
  currentPageParameters: {}, // The parameters used to get the search results of the current page
  agencies: [],
  fetched: null, // Date Time
  fetching: false,
  searchId: null,
  meta: {},
  referringUrl: '',
  location: null,
  locationCount: 0,
  widerCount: 0,
  distanceUsed: 0,
  defaultOrder: '',
  defaultOrderCND: '',
  quickSearch: null,
  agencyList: [],
  static: false,
  page_type: null,
};

const defaultParameters = {
    location: '',
    location_id: '',
    industry: null,
    skill: null,
    subcat: null,
    emp_cand: null,
    job_types: [],
};

const mutations = {
  setParameter(state, { key, value }) {
    console.log(`* Mutation: search/setParameter('${key}', '${value}')`);
    state.parameters[key] = value;
    if (key == 'emp_cand') {
        jQuery(document).trigger('tc_change_contact_type', value);        
    }
  },
  setParameters(state, parameters) {
    state.parameters = parameters;
  },
  setAgencies(state, agencies) {
    state.agencies = agencies;
  },
  setAgencyList(state, agencyList) {
    state.agencyList = agencyList;
  },
  setFetched(state, fetched) {
    state.fetched = fetched;
  },
  setFetching(state, fetching = true) {
    state.fetching = fetching;
  },
  setSearchId(state, searchId) {
    state.searchId = searchId;
  },
  setMeta(state, meta) {
    state.meta = meta;
  },
  setReferringUrl(state, referringUrl) {
    state.referringUrl = referringUrl;
  },
  setCurrentPageParameters(state, parameters) {
    state.currentPageParameters = parameters;
  },
  setLocation(state, location) {
    state.location = location;
  },
  setStatic(state, isStatic) {
    state.static = isStatic;
  },
};

const getters = {
  empOrCand(state) {
    return state.parameters.emp_cand;
  },
  searchQuery(state) {
    
    // this will give us an empty array if job types has any of the values we don't want.
    // sending an array is a legacy thing, hopefully we can get rid later.
    let job_types = state.parameters.job_types == '' ? [] : state.parameters.job_types;
    job_types = job_types?.filter(x => ![undefined, null, 'any'].includes(x)) ?? [];
    
    let order;
    if (state.parameters.emp_cand == 'emp') {
        order = ['covers', 'distance', 'standard'].includes(state.parameters.order)
            ? state.parameters.order
            : state.defaultOrder;
    } else if (state.parameters.emp_cand == 'cnd') {
        order = state.defaultOrderCND;
    } else {
        order = state.defaultOrder;
    }

    // Hate doing this, to compare V2 and V3, we 'need' empty parameters
    // arrrrgghhhhhh!!!!!
    const params = omitBy(
      {
        do: 'search',
        order,
        location: state.parameters.location === null ? '' : state.parameters.location,
        location_id: state.parameters.location_id === null ? '' : state.parameters.location_id,
        industry: state.parameters.industry,
        skill: state.parameters.skill ?? '',
        'job_types[]': (job_types.length > 0) ? job_types : '',
        emp_cand: state.parameters.emp_cand,
        // skip page 1 parameter, its the default
        page: (state.parameters.page == 1) ? null : state.parameters.page,
      },
      isNull
    );
    return params;
  },
  currentLocationOption(state) {
    if (state.parameters?.location_id) {
      return {
        id: state.parameters.location_id,
        location: state.parameters.location,
      };
    }
    if (state.location && state.parameters.hasOwnProperty('location')) {
      if (state.parameters.location === state.location.URLCode) {
        return {
          id: state.location.AggregateLocationID,
          location: state.location.Label,
        };
      }
    }

    return null;
  },
  parametersChanged(state) {
    const userEditableFields = [
      'industry',
      'subcat',
      'skill',
      'location',
      'location_id',
      'emp_cand',
      'job_types',
    ];

    // Check to see if the parameters a user can change have been changed on the current search page
    const pageParams = pick(
      state.currentPageParameters ?? {},
      userEditableFields
    );
    const currentParams = pick(state.parameters ?? {}, userEditableFields);

    return !isEqual(pageParams, currentParams);
  },
  shouldShowTickAndIndustryList( state, getters, rootState, rootGetters ) {
    // this removes the industry list from everywhere except search
    // and on skill/subcat pages if there is TOPT
    let pageType = rootGetters['pagetext/getPageType'];
    let hasText = rootGetters['pagetext/hasPageText'];
    let result = true;
    if (['town','county','region','industry','industrytown','industrycounty'].includes(pageType)) {
        result = false;
    } else if (['skill', 'subcat'].includes(pageType) && hasText) {
        result = false;
    }
    return result;
  },
  makePersonalPageURL: (state) => (agency) => {
    let u = agency.personal_page_url;
    let p = [];
    if (state.parameters.emp_cand) {
        p.push('emp_cand=' + state.parameters.emp_cand);
    }
    if (state.searchId && !state.static) {
        p.push('search_id=' + state.searchId);
    }
    if (p.length > 0) {
        u += '?' + p.join('&');
    }
    return u;
  },
  shouldSwitchHeadingTagForPath: (state) => (path) => {
    return [
        'agencysearch/sport/agencysearch.htm',
        'agencysearch/agriculture/agencysearch.htm',
        'agencysearch/childcare/agencysearch.htm',
        'agencysearch/rail/agencysearch.htm',
        'agencysearch/catering/skills/bars/bars.htm',
        'agencysearch/travel/skills/cruiseship/cruiseship.htm',
        'agencysearch/education/skills/primary/classroomassistant.htm',
        'agencysearch/engineering/skills/rail/pts.htm',
        'agencysearch/bytown/middlesex-hounslow.htm',
        'agencysearch/bytown/westmidlands-coventry.htm',
        'agencysearch/bytown/westyorkshire-huddersfield.htm',
        'agencysearch/bytown/countyantrim-belfast.htm',
        'agencysearch/security/countysearch/england/yorkshire.htm',
        'agencysearch/security/countysearch/england/merseyside.htm',
        'agencysearch/childcare/countysearch/england/kent.htm',
        'agencysearch/government/countysearch/england/westmidlands.htm',
        'localsearch/industrial-recruitment-agencies-in-nottingham',
        'localsearch/aviation-recruitment-agencies-in-birmingham',
        'localsearch/childcare-recruitment-agencies-in-leeds',
        'localsearch/catering-recruitment-agencies-in-belfast',
    ].includes(path.replace(/^\//, ''));
  },

};

const actions = {
  async doSearch({ state, commit, dispatch }, params) {
    if (state.fetching) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      commit('setFetching');

      try {
        const response = await axios.post('/api/search', { ...params });

        if (response.status !== 200) {
          reject();
          return;
        }

        commit('setCurrentPageParameters', { ...params });
        commit('setFetched', new Date());
        commit('setParameters', params);
        commit('setAgencies', response.data.search.agencies);
        commit('setMeta', response.data.search.meta);
        commit('setLocation', response.data.search.location);
        commit('setAgencyList', response.data.search.agencyList);
        dispatch('pagetext/updateState', response.data.pagetext, {
          root: true,
        });
        dispatch('contact/updateFakeData', response.data.contact, {
          root: true,
        });

        resolve();
      } catch {
        reject();
      } finally {
        commit('setFetching', false);
      }
    });
  },
  async doStaticSearch({ state, commit, dispatch }, staticPagePath) {
    if (state.fetching) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      commit('setFetching');
      try {
        const response = await axios.get(`/api/search${staticPagePath}`);

        if (response.status !== 200) {
          reject();
          return;
        }

        
        commit('setFetched', new Date());
        commit('setAgencies', response.data.search.agencies);
        commit('setParameters', response.data.search.parameters);
        commit('setCurrentPageParameters', {
          ...response.data.search.parameters,
        });
        commit('setMeta', response.data.search.meta);
        commit('setLocation', response.data.search.location);
        commit('setAgencyList', response.data.search.agencyList);
        dispatch('pagetext/updateState', response.data.pagetext, {
          root: true,
        });
        dispatch('contact/updateFakeData', response.data.contact, {
          root: true,
        });

        resolve();
      } catch {
        reject();
      } finally {
        commit('setFetching', false);
      }
    });
  },
  async getStaticParameters({ commit }, path) {
    const request = new Promise(async (resolve, reject) => {
      path = path.startsWith('/') ? path : `/${path}`;
      const endPoint = `/api/parameters${path}`;

      let response;
      try {
        response = await axios.get(endPoint);
      } catch {
        reject();
        return;
      }

      // ensure the URL (path) is always present in the parameters
      response.data.url = path;

      commit('setParameters', response.data);
      resolve(response.data);
    });

    return await request;
  },
  async resetState({ commit }) {
    commit('setParameters', defaultParameters);
    commit('setCurrentPageParameters', defaultParameters);
    commit('setAgencies', []);
    commit('setFetched', null);
    commit('setFetching', false);
    commit('setSearchId', null);
    commit('setMeta', {});
    commit('setLocation', defaultState.location);
  },
  async logSearch({ state, commit }, originPoint) {
    // If a search is in progress, don't log a new search
    if (state.fetching) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      let stData = (typeof(window.ST_DATA) !== 'undefined' ? window.ST_DATA : null);
      let stPresent = (stData !== null ? true : false);
      let stTimestamp = window.ST_TIMESTAMP;
      let vueStorePresent = (window.stores.search ? true : false);

      let data = {
        empCand: state.parameters?.emp_cand,
        industry: state.parameters?.industry,
        skill: state.parameters?.skill,
        subcat: state.parameters?.subcat,
        order: state.parameters?.order,
        jobTypes: !isArray(state.parameters?.job_types)
          ? []
          : [state.parameters.job_types[0]],
        locationId: state.parameters?.location_id,
        resultCount: state.meta?.count,
        processingTime: state.meta?.processing_time,
        referringPage: state.referringUrl,
        currentPage: location.pathname,
        userAgent: navigator.userAgent,
        originDataPresent: stPresent,
        originData: stData,
        originPoint: originPoint,
        originTimestamp: stTimestamp,
        vueStorePresent: vueStorePresent,
        thisURL: window.location.href,
      };

      // Add whether an FTLA was included, and the FTLA tag to log search
      const ftlaAgency = state.agencies.find(
        (agency) => agency.featured_top_level_agency
      );
      if (ftlaAgency !== undefined) {
        data.ftla = 'y';
        data.ftla_tag = ftlaAgency.AgencyTag;
      }

      try {
        const response = await axios.post('/internal/logSearch', data);

        if (response.status === 200) {
          commit('setSearchId', response.data.searchId);
          resolve();
        } else {
          commit('setSearchId', null);
          reject();
        }
      } catch {
        commit('setSearchId', null);
        reject();
      } finally {
        delete window.ST_TIMESTAMP;
        delete window.ST_DATA;
      }
    });
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: defaultState,
};
